import { Crown, Check } from "lucide-react";
import { FadeIn } from "./FadeIn";
import { BOOKING_URL, MEMBERSHIPS, MEMBERSHIP_BENEFITS } from "../data/content";

export const Memberships = () => (
  <section
    id="memberships"
    data-testid="memberships-section"
    className="px-4 sm:px-8 lg:px-12 py-16 md:py-24 max-w-7xl mx-auto"
  >
    <FadeIn className="flex flex-col gap-4 mb-6 items-center text-center">
      <p className="text-amber-400 text-xs font-bold uppercase tracking-[0.3em]">
        VIP Tiers
      </p>
      <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-white">
        Membership Cards
      </h2>
      <div className="flex flex-wrap justify-center gap-3 mt-2">
        {MEMBERSHIP_BENEFITS.map((b) => (
          <span
            key={b}
            data-testid={`membership-benefit-${b.toLowerCase().replace(/\s+/g, "-")}`}
            className="flex items-center gap-2 text-white/70 text-xs sm:text-sm border border-white/10 bg-white/5 px-4 py-2 rounded-full"
          >
            <Check className="w-4 h-4 text-emerald-400" /> {b}
          </span>
        ))}
      </div>
    </FadeIn>
    <div className="flex flex-col gap-6 w-full max-w-4xl mx-auto mt-12">
      {MEMBERSHIPS.map((m, i) => (
        <FadeIn key={m.tier} delay={i * 0.1}>
          <div
            data-testid={`membership-card-${m.tier.toLowerCase()}`}
            className={`bg-[#0c0c0c] border border-white/10 rounded-2xl p-6 sm:p-8 flex flex-col md:flex-row items-center justify-between gap-6 ${m.border} transition-all duration-300 hover:-translate-y-1`}
          >
            <div className="flex items-center gap-4">
              <div className="p-3 rounded-xl bg-white/5 border border-white/10">
                <Crown className={`w-7 h-7 ${m.accent}`} />
              </div>
              <div>
                <h3 className={`font-serif text-2xl font-black ${m.accent}`}>
                  {m.tier} Tier
                </h3>
                <p className="text-white/50 text-sm font-light">
                  Prepaid spa credit membership
                </p>
              </div>
            </div>
            <div className="flex items-center gap-8 text-center">
              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider">
                  You Pay
                </p>
                <p className="text-white font-serif text-2xl font-bold">
                  {m.pay}
                </p>
              </div>
              <div className="text-amber-400 font-serif text-2xl">→</div>
              <div>
                <p className="text-white/50 text-xs uppercase tracking-wider">
                  You Get
                </p>
                <p
                  data-testid={`membership-credit-${m.tier.toLowerCase()}`}
                  className="font-serif text-2xl font-black bg-gradient-to-r from-amber-300 via-yellow-500 to-amber-600 bg-clip-text text-transparent"
                >
                  {m.credit}
                </p>
              </div>
            </div>
            <a
              href={BOOKING_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`membership-book-btn-${m.tier.toLowerCase()}`}
              className="border border-amber-400/50 text-amber-300 px-6 py-3 rounded-full text-xs font-bold uppercase tracking-[0.2em] hover:bg-gradient-to-r hover:from-amber-300 hover:to-amber-600 hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              Get Membership
            </a>
          </div>
        </FadeIn>
      ))}
    </div>
  </section>
);
